import { QuestDefinition } from './types';

/**
 * Quest definition for the Auto Floor tool (AutoFloorTool / 'auto_floor')
 *
 * Maps internal stages to user-facing tooltip translation source strings.
 * These strings must be registered in apps/client/src/translation/questTranslations.ts
 * for the extraction CLI to pick them up.
 */
export const autoFloorQuest: QuestDefinition = {
  toolName: 'auto_floor',
  states: {
    selecting: 'draw a bounding box around the building area with equal floor heights',
    detecting: 'detecting floors',
    floor_selection: 'click a level to isolate it. Double click its bar or press Enter to add it',
    all_added: 'all floors added, continue to room creation',
  },
  defaultKey: 'draw a bounding box around the building area with equal floor heights',
};
